import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.tsx';
import { clsx } from 'clsx';
import {
  formHeading,
  formFieldsContainer,
  submitAuthFormButton,
  subButton,
  cardBody,
} from '../../_auth/page.css';

export const ChooseUsernameFallback = () => {
  return (
    <form>
      <Skeleton className={formHeading} height={32} width={'80%'} />
      <Skeleton className={cardBody} height={14} width={'75%'} />
      <div className={formFieldsContainer}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} height={45} width={'100%'} radius={16} />
        ))}

        <Skeleton
          className={clsx(submitAuthFormButton, subButton)}
          height={20}
          width={100}
        />
        <Skeleton className={submitAuthFormButton} height={48} width={'100%'} />
      </div>
    </form>
  );
};
